<template>
    <v-layout row wrap>
        <v-flex sm10 md8 lg6>
            <v-autocomplete
                    small-chips
                    prepend-inner-icon="clear"
                    @click:prepend-inner="clear"
                    @change="change"
                    :loading="loading"
                    :items="items"
                    :search-input.sync="search"
                    :label="label"
                    :cache-items="true"
                    v-model="inputValue"
                    item-text="suggest"
                    item-value="value"
                    class="ma-0"
                    flat
                    hide-no-data
                    hide-details
                    :placeholder="placeholder"
            ></v-autocomplete>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    value: String,
    title: String,
    label: String,
    index: String,
    placeholder: String
  },
  data () {
    return {
      inputValue: this.value,
      loading: false,
      items: [],
      search: null,
      debounceSearch: this.lodash.debounce(this.remoteSearch, 500),
      throttleSearch: this.lodash.throttle(this.remoteSearch, 200)
    }
  },
  methods: {
    preselect (value) {
      this.items = [{ suggest: value, value: value }]
      this.inputValue = value
      this.$emit('input', this.inputValue)
    },
    change () {
      this.$log.debug(`Autocomplete change: ${this.inputValue}`)
      this.$emit('input', this.inputValue)
    },
    // execute () {
    //   this.$log.debug(`Autocomplete execute: ${this.inputValue}`)
    //   this.$emit('input', this.inputValue)
    // },
    clear () {
      this.inputValue = null
      this.$emit('input', null)
    },
    remoteSearch (query) {
      this.loading = true

      this.axios.get(`autocomplete`, {
        params: {
          i: this.index,
          q: query,
          s: 100
        } })
        .then(response => {
          this.$log.debug('Autocomplete OK')
          this.items = response.data.data
        })
        .catch(e => {
          this.$log.error(e)
        }).finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search (val) {
      if (!val) return
      if (val.length < 5 || val.endsWith(' ')) {
        this.throttleSearch(val.trim())
      } else {
        this.debounceSearch(val.trim())
      }
    }
  }
}
</script>

<style scoped>

</style>
